import { createSlice } from '@reduxjs/toolkit'

export const authSlice = createSlice({
  name: 'auth',
  initialState: {
    user: null
  },
  reducers: {
    setAuth: (state, action) => {
      state.user = action.payload.user;
    }
  },
})

// Action creators are generated for each case reducer function
export const { setAuth, setIsGroupIdAllowed } = authSlice.actions

export default authSlice.reducer